<template>
  <div class="mirrorContent">
    <Headermenu :menu-color="'mirror'"
                :is-ai="true"></Headermenu>
    <div class="mirrorSpace">
      <div class="item categoryBox">
        <MirrorCategory />
      </div>
      <div class="item productBox">
        <MirrorProduct />
      </div>
      <div class="item previewBox">
        <MirrorPreview />
      </div>
      <div class="item mergeBox">
        <MirrorMerge />
      </div>
      <div class="item mergePreviewBox">
        <MirrorImageView />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Headermenu from "./components/HeaderMenu.vue"
import MirrorCategory from "./components/mirror/Category.vue"
import MirrorProduct from "./components/mirror/Product.vue"
import MirrorPreview from './components/mirror/Preview.vue'
import MirrorMerge from './components/mirror/Merge.vue'
import MirrorImageView from './components/mirror/MergeImageView.vue'
console.log('first commit')
</script>

<style scoped lang="less">
.mirrorContent {
  background: url('../assets/mirror_imgs/background.jpg') center/cover repeat-y;
  position: relative;
  height: 100vh;

  :deep(.header-menu) {
    background: none;
    color: #fff !important;
    position: sticky;
    top: 0;
    left: 0;

    .flex-btn {

      :deep(.user-profile-control) {
        color: #fff !important;
      }
    }

    .menuLabel {
      color: #fff !important;
    }

    .username {
      color: #fff;
    }
  }

  .mirrorSpace {
    display: flex;
    flex-direction: row;
    margin: 45px;
    justify-content: space-around;
    align-items: stretch;
    /* 确保子元素高度拉伸匹配父容器 */
    height: 85%;

    /* 分布 */
  }

  .item {
    padding: 20px;
    padding-right: 0px;
    overflow: hidden;
    //background: rgba(255, 255, 255, 0.2);
    // border: 1px solid white;
  }

  .categoryBox {
    flex: 0 0 10%;
  }

  .productBox {
    flex: 0 0 20%;
  }

  .previewBox {
    flex: 0 0 16%;
  }

  .mergeBox {
    flex: 0 0 18%;
  }

  .mergePreviewBox {
    flex: 1;
    margin-right: 0px;
  }

}
</style>
